<template>
  <BandejaPedidos/>
</template>
<script>
import BandejaPedidos from "./components/BandejaPedidos";
export default {
  components: { BandejaPedidos },
};
</script>
